//
//
//
//
//
//
//
//
//

import products from '@/shared/datasets/products';
import SupportRow from '~/components/SupportRow.vue';
import FinancingAboveTheFold from '~/components/financing/Financing_AboveTheFold.vue';
import FinancingRow from '~/components/financing/Financing_Details.vue';
import FinancingCallToAction from '~/components/financing/Financing_CallToAction.vue';
import { metaData } from '~/configuration/metaData';

export default {
  name: 'Financing',
  head: {
    ...metaData.financing,
  },
  components: {
    FinancingAboveTheFold,
    FinancingRow,
    FinancingCallToAction,
    SupportRow,
  },
  data: () => ({
    product: products.fightcampConsoleBag,
  }),
  mounted() {
    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  },
};
